/* Carter Chronicles — Theme JS */
(function() {
  'use strict';

  // === CART DRAWER ===
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  cartOverlay?.addEventListener('click', closeCart);
  document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCart);

  document.querySelectorAll('[data-open-cart]').forEach(btn => {
    btn.addEventListener('click', openCart);
  });

  // === ADD TO CART ===
  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      const data = await res.json();
      if (data.id) {
        await updateCartCount();
        openCart();
        await refreshCartItems();
      }
    } catch (e) { console.error('Add to cart error:', e); }
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch(e) {}
  }

  async function refreshCartItems() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const itemsEl = document.querySelector('.cart-drawer__items');
      const subtotalEl = document.querySelector('.cart-subtotal__amount');
      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = `<div class="cart-drawer__empty">
          <svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>Your cart is empty</p></div>`;
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <div class="cart-item__image"><img src="${item.image}" alt="${item.title}"></div>
            <div class="cart-item__body">
              <div class="cart-item__name">${item.product_title}</div>
              <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
              <div class="cart-item__price">${formatMoney(item.final_price)}</div>
            </div>
          </div>`).join('');
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } catch(e) {}
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // === PRODUCT FORM ===
  const addToCartForms = document.querySelectorAll('[data-product-form]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      await addToCart(variantId, qty);
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    });
  });

  // === QUANTITY SELECTOR ===
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    selector.querySelector('.qty-btn[data-minus]')?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    selector.querySelector('.qty-btn[data-plus]')?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  // === GALLERY THUMBNAILS ===
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.product-gallery__main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // === VARIANT SELECTION ===
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const hiddenInput = document.querySelector('[name="id"]');
      if (hiddenInput && btn.dataset.variantId) hiddenInput.value = btn.dataset.variantId;
    });
  });

  // === MOBILE MENU ===
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  mobileBtn?.addEventListener('click', () => {
    mobileNav?.classList.toggle('open');
  });

  // === NEWSLETTER ===
  document.querySelector('.newsletter-form')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = e.target.querySelector('.newsletter-input')?.value;
    const btn = e.target.querySelector('.btn');
    if (!email) return;
    btn.disabled = true; btn.textContent = 'Subscribing...';
    await new Promise(r => setTimeout(r, 1000));
    btn.textContent = '✓ Subscribed!';
    btn.style.background = '#166534';
  });

  // === INIT CART COUNT ===
  updateCartCount();

})();
